import React from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/ui/tooltip";
import { Text } from "components/text";
import { Circle, CircleColorType } from "./Circle";

export { CircleColorType } from "./Circle";

export interface CircleCounterProps {
  value: number;
  maxValue?: number;
  label?: string;
  color?: CircleColorType;
  showWarning?: boolean;
  tooltip?: {
    title?: string;
    description?: string[];
  };
}

export const CircleCounter: React.FC<CircleCounterProps> = ({
  value,
  maxValue,
  label = "",
  color = CircleColorType.Green,
  showWarning = true,
  tooltip,
}) => {
  const counter = maxValue ? `${value}/${maxValue}` : value.toString();
  const display = label ? `${counter} ${label}` : counter;

  const counterElement = (
    <div
      className="flex items-center space-x-2 text-xs text-secondary-500 cursor-pointer"
      data-testid="circle-counter"
    >
      <Circle
        color={color}
        showWarning={showWarning}
        value={value}
        maxValue={maxValue}
      />
      <span>{display}</span>
    </div>
  );

  if (!tooltip) {
    return counterElement;
  }

  return (
    <Tooltip>
      <TooltipContent>
        <div
          className="flex flex-col items-start"
          data-testid="circle-counter-tooltip-content"
        >
          {tooltip.title && (
            <Text variant="captionStrong" className="mb-3">
              {tooltip.title}
            </Text>
          )}
          {tooltip.description &&
            tooltip.description.map((line) => (
              <Text key={line} variant="caption">
                {line}
              </Text>
            ))}
        </div>
      </TooltipContent>
      <TooltipTrigger>{counterElement}</TooltipTrigger>
    </Tooltip>
  );
};
